// API`s

//export const API_ENTERPRISE = import.meta.env.VITE_API_ENTERPRISE
const normalizeBaseUrl = (value?: string, forbiddenSegment?: string): string => {
  if (!value) {
    return ''
  }

  let trimmed = value.trim()
  while (trimmed.endsWith('/')) {
    trimmed = trimmed.slice(0, -1)
  }

  if (forbiddenSegment) {
    const normalizedSegment = forbiddenSegment.replace(/^\/+|\/+$/g, '').toLowerCase()
    if (normalizedSegment) {
      const suffix = `/${normalizedSegment}`
      if (trimmed.toLowerCase().endsWith(suffix)) {
        trimmed = trimmed.slice(0, trimmed.length - suffix.length)
      }
    }
  }

  return trimmed ? `${trimmed}/` : ''
}

export const API_AUTH = normalizeBaseUrl(import.meta.env.VITE_API_AUTH)
export const API_AUTHORIZATION = normalizeBaseUrl(import.meta.env.VITE_API_AUTHORIZATION)

export const API_BUSINESS = normalizeBaseUrl(import.meta.env.VITE_API_BUSINESS)

export const API_RATEDATA = normalizeBaseUrl(import.meta.env.VITE_API_RATEDATA)

export const API_OPERATIONS = normalizeBaseUrl(import.meta.env.VITE_API_OPERATIONS, 'operation')

export const API_OPERATIONS_VIEW = normalizeBaseUrl(import.meta.env.VITE_API_OPERATIONS_VIEW, 'operation-view')

export const API_MASTERDATA = normalizeBaseUrl(import.meta.env.VITE_API_MASTERDATA, 'masterdata')
